// extracted by mini-css-extract-plugin
module.exports = {"FiltersWrap":"DisplayFilter_FiltersWrap__2T2IR"};